import { combineReducers } from 'redux'

import behavior from './behaviorReducer'
import messages from './messagesReducer'
import quickButtons from './quickButtonsReducer'
import menu from './menuReducer'
import toc from './tocReducer'
import theme from './themeReducer'
import styles from './stylesReducer.js'

const reducerChatWidget = combineReducers({
  behavior, messages, quickButtons, menu, theme, styles, toc
})

export default reducerChatWidget



// WEBPACK FOOTER //
// ./src/ChatWidget/store/reducers/index.js